import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default useStyles;
